import React from 'react';
import { Grid, Icon } from "@shell-b2c/web-design-system";
import { makeStyles } from '@mui/styles';
import Styling from './style';
import { Hidden } from "@mui/material";


const iconSwitch = {
    back: (
        <Icon
        type="arrow-left"
        style={Styling.arrowLeftIcon}
        data-testid="arrow-left"
        />
    ),
    close: <Icon type="close" data-testid="close" />,
};

const NewBrandHeader = ({
    app,
    header,
    handleToggleTag,
    handleRemoveAction,
    isMobile,
    translate,
    handleRedirectToCVP,
  }) => {
    const { disabledHeader, background } = header;
    const styles = useStyles();

    const getIcon = (button, visible) => {
        if (!visible) {
          return <span />;
        }
        return (
          iconSwitch[button.icon] || (
            <span style={Styling.defaultICon}>{translate(button.name)}</span>
          )
        );
      };


  const handleDivClick = (actions, leftMenuEvent) => {
    if (actions.length <= 0) {
      handleClick(leftMenuEvent);
      return;
    }

    handleClick(actions[0]);
    handleRemoveAction();
  };

  const handleClick = (e) => {
    if (!header.disabledMenu) e();
  };

      const showShellLogo = () => (
        <Grid
          item
          xs={2}
          onClick={() => {
            handleToggleTag();
          }}
        >
          <Icon type="pecten-small" style={Styling.shellLogo} />
        </Grid>
      );

      const renderHeaderMobile = () => {
        const { menu, actions } = header;
        const isHeaderDisabled = menu.leftMenu.disabled || false;

        return (
            <Grid container className={styles.containerParent}>
                {!isHeaderDisabled && showShellLogo()}
                <div
                    id={'headerMenuLeft'}
                    onClick={(e) => {
                        e.preventDefault();
                        handleDivClick(actions, menu.leftMenu.event);
                    }}
                    className={styles.child1}
                >
                    <Hidden smUp>
                        <div style={menu.leftMenu.alignment === 'right' ? Styling.newBrandRight : Styling.left}>
                            {getIcon(menu.leftMenu, menu.leftMenu.mobile)}
                        </div>
                    </Hidden>
                    
                </div>
            </Grid>
        );
    };
    
    const renderHeaderDesktop = () => {
        const redirect = app.query.redirect;
        const hasCustomEvent =
            redirect && header.menu.rightMenu.event && header.menu.rightMenu.desktop;
        const isHeaderDisabled = header.menu.rightMenu.disabled || false;
        const headerEvent = hasCustomEvent
            ? header.menu.rightMenu.event
            : handleRedirectToCVP;
        const icon = getIcon(header.menu.rightMenu, header.menu.rightMenu.desktop);
        return (
            <Grid container className={!isHeaderDisabled ? styles.containerParent: {}}>
                {!isHeaderDisabled && showShellLogo()}
                {redirect && !isHeaderDisabled && (
                <React.Fragment>
                    <Grid item xs={9} />
                    <div onClick={headerEvent} className={styles.child2}>
                    <Hidden smDown>
                        <div style={Styling.right}>{icon}</div>
                    </Hidden>
                    </div>
                </React.Fragment>
                )}
            </Grid>
        );
    };

    return (
          !disabledHeader && (<Grid
            item
            xs={12}
            style={{
                ...Styling.newBrandHeaderContainer,
                ...(isMobile ? Styling.newBrandheaderContainerMobile : {}),
                ...(background ? { background } : {}),
            }}
        >
            {isMobile ? renderHeaderMobile() : renderHeaderDesktop()}
        </Grid>
    )
  ) ;
  }

  const useStyles = makeStyles({
    containerParent: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.2)",
      height: '56px',
      padding: '0 8px',
    },
    child1: {
      display: 'flex',
    },
    child2: {
      display: 'flex',
    },
    child3: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  });

export default NewBrandHeader;